<template>
  <div class="agreement-input">
    <div class="form-group">
      <label v-bind:for="field.name" class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <div class="radio">
          <label>
            <input type="radio" v-bind:name="field.name" v-model="field.value" value="1"> {{ field.agree }}
          </label>
        </div>
        <div class="radio" v-if="!field.forced">
          <label>
            <input type="radio" v-bind:name="field.name" v-model="field.value" value="0"> {{ field.disagree }}
          </label>
        </div>
        <span class="form-validation-error" v-show="!field.valid && field.dirty && field.forced">{{ field.forced }}</span>
        <span class="form-validation-error" v-show="!field.valid && field.dirty && !field.forced">You must select an option</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreementInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  ready () {
    this.validateField(this.field.value)
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  },
  methods: {
    validateField (val) {
      if (val || val === false) {
        this.field.dirty = true
        this.field.valid = true
      } else {
        this.field.valid = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AgreementInput.vue?7a274814